import { useState, useEffect } from 'react'
import { ProductPrint } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Icon from 'components/priority/Icon/Icon'
import Text from 'components/priority/Text/Text'
import { useIsAdmin } from '@/hooks/utility/useIsAdmin'
import * as S from './InsertItems.styled'
import isEven from 'utils/global/isEven'

export const PageShuffleItem = ({
  index,
  theme,
  themeOverride,
  value,
  deletePage,
  goToPage,
  disabled,
  preventDelete,
  isDeleting,
}) => {
  const [deleting, setDeleting] = useState(false)
  const isAdmin = useIsAdmin()

  useEffect(() => {
    if (!isDeleting) {
      setDeleting(false)
    }
  }, [isDeleting])

  //a failed page create can leave an undefined slot in the pages array; skip it
  //rather than dereferencing value.disabled / value.pageProperties and crashing
  if (!value) return null

  return (
    <Flex
      full
      align="center"
      justify="space-between"
      height="100%"
      opacity={deleting ? '.5' : '1'}
      onClick={() => goToPage(index)}
    >
      <Flex align="center">
        <S.DragIcon
          margin="0 24px 0 0"
          data-movable-handle
          data-testid="page-shuffler-handle"
          icon="pageShuffleDrag"
          tabIndex={-1}
          disabled={value.disabled}
        />
        <S.ProductWrapper>
          <ProductPrint
            // leaving as comment in case we bring back page shuffling
            // isPageShuffleItem={true}
            position="relative"
            theme={theme}
            themeOverride={themeOverride}
            page={value}
            isEven={isEven(value.pageProperties.pageNumber)}
          />
        </S.ProductWrapper>
      </Flex>
      <Flex align="center" width="70%" justify="space-between">
        <Flex column>
          <Text margin="0 24px 0 0">
            Page {value.pageProperties.pageNumber}
          </Text>
          <Text color="gray2">
            {value?.pageProperties?.product?.includes('Register Book')
              ? `${isEven(value.pageProperties.pageNumber) ? 'Left' : 'Right'}`
              : `${isEven(value.pageProperties.pageNumber) ? 'Back' : 'Front'}`}
          </Text>
        </Flex>

        {!disabled && !preventDelete && isAdmin && (
          <Icon
            disabled={disabled}
            icon="archive"
            fill="gray2"
            margin="0 24px 0 0"
            data-testid="page-shuffler-delete"
            onClick={(e) => {
              setDeleting(true)
              deletePage(e, index)
            }}
          />
        )}
      </Flex>
    </Flex>
  )
}

export default PageShuffleItem
